module.exports = __webpack_public_path__ + "de317df560e43adefdc644dc5d0c33e9.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/kz.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/kz.svg
// module chunks = 0